import FuseNavigation from '@/@fuse/core/FuseNavigation';
import clsx from 'clsx';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

const Navigation = ({ active, className, dense, layout = 'vertical' }) => {
	const navigation = useSelector(({ fuse }) => fuse.navigation);
	// Per-school feature flag — hide the Billing menu entirely when off.
	// TOP-LEVEL school first: it's the masqueraded school, set by the school
	// dialog and kept fresh by Auth.jsx on every boot. data.school is the
	// ENTRY-time snapshot (an owner's own school), which must not shadow the
	// school actually being viewed.
	const billingEnabled = useSelector(({ auth }) => (auth?.user?.school ?? auth?.user?.data?.school)?.billing_enabled);

	const filteredNavigation = useMemo(
		() => (billingEnabled ? navigation : navigation.filter((item) => item.id !== 'billing')),
		[navigation, billingEnabled]
	);

	return (
		<FuseNavigation
			active={active}
			className={clsx('navigation', className)}
			dense={dense}
			layout={layout}
			navigation={filteredNavigation}
		/>
	);
};

export default Navigation;
